"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cssClassesHelper = require("../../../../helpers/cssClassesHelper");
require("./ContentWithFooterLayoutTemplate.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * This is layout for following case:
 *  ___________________________
 * |                           |
 * | {content}                 |
 * |                           |
 * |___________________________|
 * | {footer}                  |
 * |___________________________|
 *
 * Note: footer is always attached to bottom
 */
var ContentWithFooterLayoutTemplate = function ContentWithFooterLayoutTemplate(props) {
  var children = props.children,
    customClass = props.customClass,
    classModifiers = props.classModifiers,
    footer = props.footer;
  var classes = (0, _cssClassesHelper.getBEMClasses)('content-with-footer-lt', customClass);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('layout-template', classModifiers)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('content', classModifiers)
  }, children), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('footer', classModifiers)
  }, footer));
};
ContentWithFooterLayoutTemplate.propTypes = {
  children: _propTypes["default"].element.isRequired,
  footer: _propTypes["default"].element.isRequired,
  customClass: _propTypes["default"].string,
  classModifiers: _propTypes["default"].arrayOf(_propTypes["default"].string)
};
ContentWithFooterLayoutTemplate.defaultProps = {
  customClass: 'custom-retail-widget'
};
var _default = exports["default"] = ContentWithFooterLayoutTemplate;